import $ from 'cash-dom';
import Utils from './Utils';
import Ajax from './ajax';

class PopupScanCheck {
	constructor() {
		this._scanInfo = {
			ip: null,
			location: null,
			isp: null,
			isp_tracking: null,
		};
		this._scanCheckValues = [];
	}

	init() {
		this._loadScanCheckInfo().then(() => {}).catch(e => console.error(e));
	}

	_loadScanCheckInfo() {
		return new Promise((resolve, reject) => {
			Ajax.post(ajaxurl, {
				action: 'load-scan-check-info',
			}, (response) => {
				if (!response) {
					reject();
				}

				this._scanInfo = response;
				this._scanCheckValues.push(this._scanInfo.ip);
				this._scanCheckValues.push(this._scanInfo.location);
				this._scanCheckValues.push(this._scanInfo.isp);
				this._scanCheckValues.push(this._scanInfo.isp_tracking);

				resolve();
			}, 'json').fail((err) => {
				reject(err);
			});
		});
	}

	scan($popup) {
		this._sendAloomaEvent($popup);
		this._startScan($popup).then(() => {}).catch(e => console.error(e));
	}

	_sendAloomaEvent($popup) {
		if (typeof Alooma === 'undefined') {
			return;
		}

		const aloomaData = Object.assign({}, Alooma.aloomaPageData);
		const vendor = $popup.attr('data-vendor');
		const vendorId = $popup.attr('data-vendor-id');

		if (vendor) {
			aloomaData.vendor = vendor;
		}

		if (vendorId) {
			aloomaData.vendor_id = vendorId;
		}

		Alooma.aloomaSendEvent('exit_intent_scan-started', aloomaData);
	}

	async _startScan($popup) {
		const $popupScanCta = $popup.find('.popup-scan-cta');
		const $scanDone = $popup.find('.scan-done');
		const $popupEyebrowText = $popup.find('.popup-eyebrow-text');
		const $popupStatus = $popup.find('.popup-status');

		$popupScanCta.addClass('hidden');
		$popupStatus.removeClass('hidden');

		const $scanRows = $popup.find('.popup-scan-list .popup-scan-row');
		let i = 0;

		if (!this._scanInfo.ip) {
			await this._loadScanCheckInfo();
		}

		for (const scanRow of $scanRows) {
			const $scanRow = $(scanRow);
			const $icon = $scanRow.find('.popup-scan-icon');
			const $value = $scanRow.find('.popup-scan-val');
			$value.text(tr('checking...'));

			$scanRow.removeClass('state-pending').addClass('state-checking');

			$icon.addClass('popup-scan-spin');
			await Utils.setTimeout(1200);

			$value.html('<b>' + this._scanCheckValues[i] + '</b>');

			$scanRow.removeClass('state-checking').addClass('state-leaked');
			$icon.removeClass('popup-scan-spin');
			$icon.addClass('popup-scan-bad');

			++i;
		}

		$popupStatus.addClass('hidden');
		$popupScanCta.addClass('hidden');
		$scanDone.removeClass('hidden');
		$popupEyebrowText.text(this._scanCheckValues.length + ' ' + tr('risks detected'));
	}
}

export default PopupScanCheck;